<script>
    import Menu from "flowbite-svelte/Menu.svelte";
    import { ToolbarButton } from "flowbite-svelte";
    import { TempState } from "../state.svelte";

    export function openSidebar() {
        TempState.sideBarHidden = false;
    }
</script>

<div class="bg-transparent text-gray-700 black:text-gray-200 frappe:text-ctp-mauve">
    <ToolbarButton name="Open sidebar"
                   class="mx-3 hover:frappe:bg-ctp-mauve hover:frappe:text-ctp-base black:hover:text-gray-950 black:hover:bg-gray-200"
                   onclick={openSidebar}>
        <Menu class="h-6 w-6 shrink-0"/>
    </ToolbarButton>
</div>
